import { useEffect, useState } from "react"
import { useMsal, useAccount } from "@azure/msal-react"
import Typography from "@mui/material/Typography"
import { useAppDispatch } from "../util/hooks"
import { setUser } from "../features/Harmonization/HarmonizationSlice"

const WelcomeName = () => {
  const dispatch = useAppDispatch()
  const { accounts } = useMsal()
  const account = useAccount(accounts[0] || {})
  const [name, setName] = useState("")

  useEffect(() => {
    if (account?.name) {
      setName(account.name.split(" ")[1])
      dispatch(setUser(account.name))
    } else {
      setName("")
    }
  }, [account])

  if (name) {
    return (
      <Typography sx={{ color: "var(--text-primary-color)" }} variant="h6">
        Welcome, {name}
      </Typography>
    )
  } else {
    return null
  }
}

export default WelcomeName
